import styled from 'styled-components';

import { StyleColor, BaseStyledComponentProps } from '../../utils/styles-constants';

const Wrapper = styled('div')`
	display: flex;
	align-items: center;
	justify-content: flex-end;
	min-width: 50px;
	font-family: HelveticaNeue, sans-serif;
	font-size: 10px;
	line-height: 20px;
	color: ${(props: BaseStyledComponentProps) => props.theme.primary.actionColor};
`;

const CircleWrapper = styled('svg')`
	margin-left: 8px;
	transform: rotate(-90deg);
`;

const BackCircle = styled('circle')`
	fill: transparent;
	stroke: ${StyleColor.Grey200};
`;

const FrontCircle = styled('circle')`
	fill: transparent;
	stroke: ${(props: BaseStyledComponentProps) => props.theme.primary.actionColor};
	transition: stroke-dashoffset 0.5s linear;
`;

export {
	Wrapper,
	CircleWrapper,
	BackCircle,
	FrontCircle,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ProgressCircle/styles.ts